import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
// import deleteClase from "../../services/Clases/deleteClase";
import deleteTabla from "../services/deleteTabla";
import { useDispatch } from "react-redux";
import {
  addDataTitle,
  addDataDinamic,
} from "../../../redux/reducers/TableroEventos/tablaDinamicaEventosSlices";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DialogoConfimacion({
  id,
  setIdHeaders,
  setId,
  setSettings,
  useStatus,
  setData,
}) {
  const [open, setOpen] = React.useState(false);

  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Para evitar que cuando le den en eliminar entrar al rowclick
  const handleActionColmunClick = (event) => {
    event.stopPropagation();
  };

  const dispatch = useDispatch();

  // const dataTitle = useSelector((state) => state.tablaDinamicaEventos.titulo);

  const handleClick = () => {
    deleteTabla(id).then(() => {
      setIdHeaders(0);
      setId();
      dispatch(addDataTitle([]));
      setSettings({});
      dispatch(addDataDinamic([]));
      useStatus(false);
      setData([]);
    });
    handleClose();
  };

  return (
    <div onClick={handleActionColmunClick}>
      <IconButton size="small" onClick={handleClickOpen} aria-label="delete">
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirmación
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Eliminar la tabla ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            color="default"
            variant="contained"
          >
            Cancelar
          </Button>

          <Button
            autoFocus
            onClick={handleClick}
            color="primary"
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
